import React, { useRef, useEffect, useState } from 'react';

// Scales a fixed 8.5x11in (816px wide) preview to fit its container width.
export function PreviewScaler({ children, maxWidth = 816 }) {
  const wrapRef = useRef(null);
  const [scale, setScale] = useState(0.5);

  useEffect(() => {
    const update = () => {
      if (!wrapRef.current) return;
      const w = wrapRef.current.offsetWidth;
      setScale(Math.min(1, w / maxWidth));
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, [maxWidth]);

  return (
    <div ref={wrapRef} className="w-full" style={{ height: 1056 * scale }}>
      <div style={{ transform: `scale(${scale})`, transformOrigin: 'top left', width: maxWidth }}>
        {children}
      </div>
    </div>
  );
}
